import { DesignData } from 'editor/src/store/design/types';

function getMockupSizeFromDesign(design: DesignData) {
  const { width, height } = design.spreads[0].pages[0];
  return { width, height };
}

export default getMockupSizeFromDesign;
